import React from 'react';
import PropTypes from 'prop-types';

const PromotionBadges = ({ promotions = [] }) => {
  if (!promotions.length) return null;

  return (
    <div className="store-promotion-badges" aria-label="Promociones disponibles">
      {promotions.map((promotion) => (
        <span className="store-promotion-badge" key={promotion.id} title={promotion.title || 'Promoción'}>
          {promotion.label}
        </span>
      ))}
    </div>
  );
};

PromotionBadges.propTypes = {
  promotions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired,
    title: PropTypes.string,
  })),
};

export default PromotionBadges;
